import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import Graphic from '@arcgis/core/Graphic';
import Sublayer from '@arcgis/core/layers/support/Sublayer';
import TimeExtent from '@arcgis/core/TimeExtent';
import { ExportRequest } from '../_models/export-request';
import { BrowseInjectionLayerService } from '../_services/browse-injection-layer.service';
import { BrowseMapImageServiceLayerService } from '../_services/browse-map-image-service-layer.service';
import { ExportManagerService } from '../_services/export-manager.service';
import { ExportInjectionPressureManagerService } from '../_services/export-injection-pressure-manager.service';

import { BHPService } from '../_services/bhp.service';
import { InjectionService } from '../_services/injection.service';

@Component({
  selector: 'app-browse-well-details',
  templateUrl: './browse-well-details.component.html',
  styleUrls: ['./browse-well-details.component.css']
})
export class BrowseWellDetailsComponent implements OnInit {

  public wellGraphic: Graphic;
  public wellsLayer: Sublayer;
  public timeExtent: TimeExtent;
  public injectionLayer: Sublayer;

  public injectionRecords: Array<any>;

  constructor(public dialogRef: MatDialogRef<BrowseWellDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public browseMapImageServiceLayerService: BrowseMapImageServiceLayerService,
    public browseInjectionLayerService: BrowseInjectionLayerService,
    public injectionService: InjectionService,
    public bhpService: BHPService,
    public exportService: ExportManagerService,
    public exportInjectionPressureManagerService: ExportInjectionPressureManagerService
  )
  {
    //Grab the well graphic.
    this.wellGraphic = data.well;    
    this.timeExtent = data.timeExtent;

    this.injectionService.GetInjectionData(this.wellGraphic.attributes.Id);
    this.bhpService.GetInjectionPressureData(this.wellGraphic.attributes.Id);
  }

  ngOnInit(): void {
    /*this.browseInjectionLayerService.currentLayer.subscribe((injLayer) => {

      injLayer.when((il) => {

        //Handle the layer being initialized
        var query = injLayer.createQuery();

        query.where = "WellId=" + this.wellGraphic.attributes.Id;
        query.orderByFields = ["InjectionDate"];

        //Fetch the injection data for our well
        injLayer.queryFeatures(query).then((queryResult) => {
          this.injectionRecords = queryResult.features;
        });
      });
    });*/

    
  }

  public exportData() {
    var er: ExportRequest = new ExportRequest();

    er.WellIds = [this.wellGraphic.attributes.Id];


    var tes: Date = this.timeExtent.start;
    var tee: Date = this.timeExtent.end;

    var beginYear = tes.getFullYear();
    var beginMonth = tes.getMonth() + 1;
    var beginDay = tes.getDate();

    var endYear = tee.getFullYear();
    var endMonth = tee.getMonth() + 1;
    var endDay = tee.getDate();

    er.BeginYear = beginYear;
    er.BeginMonth = beginMonth; 
    er.EndYear = endYear;
    er.EndMonth = endMonth;

    er.Format = "excel";

    this.exportService.export(er, true).then(() => {
      //No need to do anything here.  The export service handles saving.
    });
  }

  public exportPressureData() {
    var er: ExportRequest = new ExportRequest();

    er.WellIds = [this.wellGraphic.attributes.Id];


    var tes: Date = this.timeExtent.start;
    var tee: Date = this.timeExtent.end;

    var beginYear = tes.getFullYear();
    var beginMonth = tes.getMonth() + 1;
    var beginDay = tes.getDate();

    var endYear = tee.getFullYear();
    var endMonth = tee.getMonth() + 1;
    var endDay = tee.getDate();

    er.BeginYear = beginYear;
    er.BeginMonth = beginMonth; 
    er.EndYear = endYear;
    er.EndMonth = endMonth;

    er.Format = "excel";

    this.exportInjectionPressureManagerService.export(er, true).then(() => {
      //No need to do anything here.  The export service handles saving.
    });
  }
}
